import { defineComponent as _defineComponent } from 'vue'
import NoSuitableBillingPlan from './NoSuitableBillingPlan.vue';
import { ProductType, FeatureTypes } from '../../Billing/billing-types';
import { useBilling } from '@/components/Billing/Billing.composables';
import BillingService from '@/components/Billing/billing-service';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

interface PlanRequired {
	plan_id: string;
	product_id: ProductType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PublishFailedBecauseBillingPlanDialog',
  props: {
    detail: null,
    reasons: null,
    planRequired: null,
    canStartTrial: { type: Boolean },
    trialEntitlements: null,
    relatedWorkflowVersionId: null,
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props = __props as {
	detail: string;
	reasons: FeatureTypes[];
	planRequired: PlanRequired;
	canStartTrial: boolean;
	trialEntitlements: FeatureTypes[];
	relatedWorkflowVersionId: number;
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}

// @ts-ignore


const { canEditBilling } = useBilling();

const openUpgradeDialog = () => {
	close();
	BillingService.openUpgradePlanDialog({
		featureId: props.reasons[0],
		planId: props.planRequired.plan_id,
		canEditBilling: canEditBilling.value,
		productId: props.planRequired.product_id,
	});
};

const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,props, canEditBilling, openUpgradeDialog, close, NoSuitableBillingPlan, AppDialog }
}

})